module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAfCAYAAADjuz3zAAAAAXNSR0IArs4c6QAAAKlJREFUSA1jnL9sRS4D439hBlLBf8YPumoqU01MTH5j08o4f9ny/9gkCIoxMixkZGB4p6OqWo7NcCaCBuBW8ADooklXbt/uPHPmDCu6MkoMZkiMjMRpOEUGg1yJy3CKDcZlOFUMxmY41QxGNvzqrTut5Cc3kEl4AFVdjGzPqMHw0BgNitGggIcAnDGaKkaDAh4CcMZoqhjCQcHCwMCYR1ZrE+5pLIz/jG8B6/pIGdxdzlwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/n-contracts_2x.png
// module id = 997
// module chunks = 0